import { Link } from 'react-router-dom';
import { Card } from '../../../../../components/card/card';
import { Rating } from '../../../../../components/rating/rating';
import { Table } from '../../../../../features/table/table';
import { TableFilterDateTimeRange } from '../../../../../features/table/table-filter/table-filter-date-time-range/table-filter-date-time-range';
import { TableFilterInput } from '../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterMultiSelect } from '../../../../../features/table/table-filter/table-filter-multi-select/table-filter-multi-select';
import { TableFilterSingleSelect } from '../../../../../features/table/table-filter/table-filter-single-select/table-filter-single-select';
import { formatRuDateTimeString } from '../../../../../helpers/date-time';
import { useLang } from '../../../../../hooks/use-lang';
import { getBaseUrl } from '../../../../../store/api/utils.ts/stand';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useReviewsStore } from '../../../../../store/use-reviews-store';

export const ReviewsTable = () => {
  const { t, getLocale } = useLang();
  const { place: branches } = useBranchesStore();
  const { reviews, pagination, isLoadingFetch } = useReviewsStore();

  return (
    <Card>
      <Table
        id="reviews"
        columnSettings
        pagination={pagination}
        isLoading={isLoadingFetch}
        onEmpty={{
          title: t('Список отзывов пуст'),
          text: t('Дождитесь, пока ваши клиенты оставят отзывы'),
        }}
        cols={{
          qr: {
            label: t('QR-код'),
            filter: (
              <TableFilterInput name="qr" suggestOptions={reviews?.map((item) => item.qr?.value)} />
            ),
          },
          content: {
            label: t('Текст отзыва'),
            filter: (
              <TableFilterInput
                name="content"
                suggestOptions={reviews?.map((item) => item.content)}
              />
            ),
          },
          rating: {
            label: t('Оценка'),
            filter: (
              <TableFilterMultiSelect
                options={[
                  { id: '1', value: '1' },
                  { id: '2', value: '2' },
                  { id: '3', value: '3' },
                  { id: '4', value: '4' },
                  { id: '5', value: '5' },
                ]}
                name="rating"
              />
            ),
          },
          branch: {
            label: t('Филиал'),
            filter: (
              <TableFilterSingleSelect
                options={branches?.map((item) => ({
                  id: String(item.id),
                  value: getLocale(item.name),
                }))}
                name="place_id"
              />
            ),
          },
          fullName: {
            label: t('Автор'),
            filter: (
              <TableFilterInput
                name="full_name"
                suggestOptions={reviews?.map((item) => item.full_name)}
              />
            ),
          },
          contactInfo: {
            label: t('Телефон'),
            filter: (
              <TableFilterInput
                name="contact_info"
                suggestOptions={reviews?.map((item) => item.contact_info)}
              />
            ),
          },
          createdAt: {
            label: t('Создано'),
            filter: <TableFilterDateTimeRange name="created_at" />,
          },
        }}
        rows={reviews?.map((item) => ({
          rowId: item.id,
          qr: item.qr && (
            <Link to={getBaseUrl() + '/qr/' + item.qr.id} target="__blank">
              {item.qr.value}
            </Link>
          ),
          content: item.content,
          rating:
            !item.rating && item.task_id ? (
              t('Создано из задачи', {
                number: item.task_id,
              })
            ) : (
              <Rating
                rate={item.rating}
                readOnly
                data-overlay={`review-${item.task_type}-${item.id}`}
              />
            ),
          branch: getLocale(branches?.find((branch) => branch.id == item.place_id)?.name),
          fullName: item.full_name,
          contactInfo: item.contact_info,
          createdAt: formatRuDateTimeString(item.created_at),
        }))}
      />
    </Card>
  );
};
